// extracted by mini-css-extract-plugin
export default {"container":"Cookies_container__V8iz4","space":"Cookies_space__PWs9H"};